export default __webpack_public_path__ + "static/media/PablitaLovelace.b8862125.png";